<app-menu></app-menu>

<section class="intranet-question-page">
  <header>
    <h1>Questionários da intranet</h1>
    <p>Responda os questionários enviados para você.</p>
  </header>

  <section class="toolbar">
    <div class="cp-tabs" role="tablist" aria-label="Filtro de questionários">
      <button
        *ngFor="let tab of tabs"
        mat-stroked-button
        type="button"
        role="tab"
        [attr.aria-selected]="activeTab === tab.key"
        [class.active]="activeTab === tab.key"
        (click)="setTab(tab.key)">
        <mat-icon>{{ tab.key === 'PENDING' ? 'schedule' : 'task_alt' }}</mat-icon>
        {{ tab.label }}
      </button>
    </div>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field">
      <mat-label>Pesquisar</mat-label>
      <mat-icon matIconPrefix>search</mat-icon>
      <input
        matInput
        type="search"
        [(ngModel)]="searchTerm"
        placeholder="Pesquisar questionário..." />
    </mat-form-field>
  </section>

  <div class="list" *ngIf="!loading && filteredItems.length; else listState">
    <article
      class="survey-card"
      *ngFor="let item of filteredItems"
      role="button"
      tabindex="0"
      (click)="openSurvey(item)"
      (keydown.enter)="openSurvey(item)"
      (keydown.space)="openSurvey(item); $event.preventDefault()">
      <div>
        <h3>{{ item.title }}</h3>
        <p>{{ item.description || 'Sem descrição' }}</p>
        <small *ngIf="activeTab === 'PENDING'">Enviado em {{ item.sent_at | date:'short' }}</small>
        <small *ngIf="activeTab === 'DONE'">
          Respondido em {{ (item.completed_at || item.sent_at) | date:'short' }}
          <ng-container *ngIf="item.responded_by_name || currentUser?.name"> · por {{ item.responded_by_name || currentUser?.name }}</ng-container>
        </small>
      </div>
      <button mat-raised-button color="primary" class="cq-primary-btn" type="button" (click)="openSurvey(item); $event.stopPropagation()">
        {{ activeTab === 'DONE' ? 'Visualizar' : 'Responder' }}
      </button>
    </article>
  </div>

  <ng-template #listState>
    <p class="state" *ngIf="loading">Carregando questionários...</p>
    <p class="state" *ngIf="!loading && !items.length && !searchTerm">
      {{ activeTab === 'DONE' ? 'Nenhum questionário respondido.' : 'Nenhum questionário pendente.' }}
    </p>
    <p class="state" *ngIf="!loading && !!searchTerm && !filteredItems.length">Nenhum questionário encontrado.</p>
    <p class="state error" *ngIf="errorMessage">{{ errorMessage }}</p>
  </ng-template>
</section>
